/* Built In Imports */
import React, { useEffect, useRef } from 'react';

/* External Imports */
import { ChakraProvider } from '@chakra-ui/react';
import TagManager from 'react-gtm-module';

/* Internal Imports */
/* Components */
// import { OptinMonsterEmbed } from '@ieo/Components/OptinMonsterEmbed';
import BuildTimeComment from '@components/Utility/BuildTimeComment';
import Layout from '@moms/Layout';
import AuthContextProvider from '@store/auth-context';
import { mixPanel } from '@utils/Mixpanel';
import { ishaTheme } from '../styles/theme/index';

/* Services */
/* Styles */
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

await import('../styles/globals.css');

/**
 * @param Component
 * @param pageProps
 */

// export default ErrorBoundary
const ISOApp = ({ Component, pageProps }) => {
  // const [blType, setBlType] = useState(nextBuildType);
  const firstUpdate = useRef(true);

  const tagManagerArgs = {
    gtmId: 'GTM-5G2NJ8P',
  };

  useEffect(() => { 

    setTimeout(function () {
      if (firstUpdate.current) {
        if (process.browser) {
          TagManager.initialize(tagManagerArgs);
        }
        firstUpdate.current = false;
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Pageview',
          url: window.location.href,
          title: window.document.title,
        });
      }
    }, 1500);

    // console.log('mixpanel before load starts', window?.location.pathname);
    const Mixpanel = mixPanel(
      window?.location.pathname,
      process?.env?.NEXT_PUBLIC_BUILDTYPE
    );

    if (Object.keys(Mixpanel)?.length > 0) {
      // console.log('mixpanel load starts', Mixpanel, window?.location.pathname);

      const mixPanelPageViewObj = {
        page_name: window?.document.title,
      };

      // Track Project samskriti page views
      if (window?.location.pathname.endsWith('/miracle-of-mind')) {
        Mixpanel.track('mom_pageview', mixPanelPageViewObj);
      }
      // else {
      //   Mixpanel.track('iso_pageview', mixPanelPageViewObj);
      // }
    }
  }, [pageProps]);

  return (
    <AuthContextProvider>
      <ChakraProvider resetCSS theme={ishaTheme}> 
        {(
            <Layout>
              <Component {...pageProps} />
            </Layout>
          )}
      </ChakraProvider>
      <BuildTimeComment />
      {/* <OptinMonsterEmbed /> */}
    </AuthContextProvider>
  );
};

export default ISOApp;
